













import { Component, Vue, Prop } from "vue-property-decorator";
import { IAnswerOption } from "../store/main.interfaces";

@Component
export default class DropdownAnswer extends Vue {
  @Prop() questionText!: string;
  @Prop() answerPossibilities!: IAnswerOption[];
  @Prop() selectedOptionValue!: any;

  emitDropdownUpdate(dropdownValue: number | string) {
    this.$emit("dropDownUpdate", dropdownValue);
  }
  set selectedOption(val: number | string) {
    this.selectedOptionValue = val;
    this.emitDropdownUpdate(val);
  }
  get selectedOption() {
    return this.selectedOptionValue;
  }
  created() {
    if (this.selectedOptionValue !== null) {
      this.selectedOptionValue = this.selectedOptionValue;
    }
  }
  updated() {
    if (this.selectedOptionValue !== null) {
      this.selectedOptionValue = this.selectedOptionValue;
    }
  }
  data() {
    return {};
  }
}
